import { render, staticRenderFns } from "./stats-overview.vue?vue&type=template&id=02de8e6a&"
import script from "./stats-overview.vue?vue&type=script&lang=js&"
export * from "./stats-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports